/** Integer-sen money helpers. Never use floats for MYR. */
export type Sen = number & { readonly __brand: "sen" };

export function sen(value: number): Sen {
  if (!Number.isSafeInteger(value) || value < 0) {
    throw new RangeError(`Invalid sen amount: ${value}`);
  }
  return value as Sen;
}

/** Format sen as "RM69.00" (Malaysia convention). */
export function formatMYR(amount: number): string {
  if (!Number.isSafeInteger(amount)) throw new RangeError(`Not integer sen: ${amount}`);
  const sign = amount < 0 ? "-" : "";
  const abs = Math.abs(amount);
  const ringgit = Math.floor(abs / 100).toLocaleString("en-MY");
  const cents = String(abs % 100).padStart(2, "0");
  return `${sign}RM${ringgit}.${cents}`;
}
